<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="MSDS 관리" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <div class="w-full d-flex justify-end mb-2">
            <v-btn v-if="isMasterConfig" color="primary" elevation="0" large class="rounded mr-2" @click="btnSdsManage"
              >소중안 제공 데이터 관리(관리자)</v-btn
            >
            <v-btn color="primary" elevation="0" large outlined class="rounded mr-2" style="background-color: #ffffff" @click="btnGoEducationMenu"
              >교육계획 상세 화면 이동</v-btn
            >
            <v-btn
              color="primary"
              elevation="0"
              large
              outlined
              class="rounded"
              :class="{ 'guide-blink-target': guideHighlightSample }"
              style="background-color: #ffffff"
              @click="btnSdsSampleData"
              >소중안 제공 데이터 불러오기</v-btn
            >
          </div>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="mainGrid"
                  class="layout-col-height00"
                  width="100%"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :selection="{ mode: 'single' }"
                  key-expr="id"
                  :focused-row-enabled="true"
                  @editing-start="onEditingStart"
                  @row-updating="onRowUpdating"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

                  <DxColumn
                    width="280px"
                    css-class="devest-grid-header-require"
                    data-field="sdsNm"
                    data-type="string"
                    alignment="left"
                    caption="화학물질명"
                    :allow-editing="true"
                  />
                  <DxColumn width="170px" data-field="casNo" data-type="string" alignment="center" caption="CAS NO." :allow-editing="true" />

                  <DxColumn
                    width="240px"
                    data-field="fileList"
                    data-type="string"
                    alignment="center"
                    caption="파일 관리"
                    cell-template="fileCellTemplate"
                    :allow-editing="false"
                  />
                  <template #fileCellTemplate="{ data: cellInfo }">
                    <div style="display: flex; align-items: center">
                      <!-- 파일 관리 팝업 -->
                      <i-dxpopup
                        :popupVisible="cellInfo.data.filePopupVisible"
                        :title="cellInfo.data.sdsNm ? `파일 관리-${cellInfo.data.sdsNm} ` : '파일 관리'"
                        @popupCloseButtonClick="btnFilePopupClose('close')"
                        :isCloseOnOutsideClick="false"
                        height="600px"
                        width="450px"
                      >
                        <template v-slot:grid>
                          <div class="v-application">
                            <v-layout column style="height: 100%">
                              <v-row style="padding: 0 16px">
                                <iFileManage
                                  class="mt-5"
                                  style="width: 100%"
                                  :ref="`detailFileUpload_${cellInfo.data.id}`"
                                  :titleDesc="''"
                                  :targetId="cellInfo.data.targetId"
                                  :targetType="'00023'"
                                  @onFileChanged="onFileChanged(cellInfo, $event)"
                                  :readOnly="false"
                                />
                              </v-row>
                            </v-layout>
                          </div>
                        </template>
                        <template v-slot:footer>
                          <div class="v-application">
                            <v-row class="d-flex justify-end" style="gap: 12px; padding-right: 10px">
                              <v-btn elevation="0" large color="primary" class="float-right rounded mt-1" @click="btnFilePopupApply(cellInfo)"
                                >적용</v-btn
                              >
                              <v-btn elevation="0" large color="desc_text" class="float-right rounded mt-1" @click="btnFilePopupClose('close')"
                                >닫기</v-btn
                              >
                            </v-row>
                          </div>
                        </template>
                      </i-dxpopup>

                      <div style="overflow-x: auto; white-space: nowrap; flex: 1 1 auto; min-width: 0; margin-right: 8px">
                        <span v-if="cellInfo.data.fileList.length > 1">
                          {{ `${cellInfo.data.fileList[0].fileNm}.${cellInfo.data.fileList[0].extension} 외 ${cellInfo.data.fileList.length - 1}개` }}
                        </span>
                        <span v-else-if="cellInfo.data.fileList.length == 1">
                          {{ `${cellInfo.data.fileList[0].fileNm}.${cellInfo.data.fileList[0].extension}` }}
                        </span>
                        <span v-else>
                          {{ '' }}
                        </span>
                      </div>
                      <div style="flex: none; position: sticky; right: 0; z-index: 2">
                        <v-icon size="28" @click="btnFilePopup(cellInfo)">mdi-file</v-icon>
                      </div>
                    </div>
                  </template>
                  <DxColumn
                    width="130px"
                    data-field="datasetYn"
                    data-type="string"
                    alignment="center"
                    caption="데이터셋 활용"
                    header-cell-template="header-cell-line-break"
                    cell-template="checkBoxCellTemplate"
                    :allow-editing="false"
                  />
                  <template #header-cell-line-break="{ data }">
                    <v-tooltip top color="primary" max-width="350px">
                      <template v-slot:activator="{ on }">
                        <div class="d-flex align-center">
                          {{ data.column.caption }}
                          <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                        </div>
                      </template>
                      <div class="tooltip-text">
                        {{ '체크되어 있는 경우, 해당 파일은 소중안 제공 데이터임을 의미합니다. \n 파일이 변경되면 체크가 자동으로 해제됩니다.' }}
                      </div>
                    </v-tooltip>
                  </template>
                  <DxColumn width="70px" data-field="ordSeq" data-type="number" alignment="center" caption="정렬" :allow-editing="true" />
                  <DxColumn
                    width="70px"
                    data-field="useYn"
                    data-type="string"
                    alignment="center"
                    caption="사용"
                    cell-template="checkBoxCellTemplate"
                    :allow-editing="false"
                  />
                  <template #checkBoxCellTemplate="{ data: cellInfo }">
                    <DxCheckBox
                      :value="cellInfo.value == 'Y' ? true : false"
                      :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)"
                      :disabled="cellInfo.column.dataField === 'datasetYn'"
                    />
                  </template>

                  <DxColumn width="120px" data-field="createdAt" data-type="string" alignment="center" :caption="`작성일자`" :allow-editing="false" />
                  <DxColumn width="120px" data-field="createdBy" data-type="string" alignment="center" :caption="`작성자`" :allow-editing="false" />
                  <!-- <DxColumn width="140px" data-field="updatedAt" data-type="string" alignment="center" :caption="`수정일자`" :allow-editing="false" /> -->
                  <!-- <DxColumn width="120px" data-field="updatedBy" data-type="string" alignment="center" :caption="`수정자`" :allow-editing="false" /> -->
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch()" @btnAdd="btnAdd()" @btnSave="btnSave()" @btnDelete="btnDelete()">
        </i-card-right>
      </v-sheet>
    </v-sheet>

    <!-- 소중안 제공 데이터 관리 팝업 -->
    <i-dxpopup
      :popupVisible="sdsManagePopupVisible"
      :title="'소중안 제공 데이터 관리'"
      @popupCloseButtonClick="sdsManagePopupVisible = false"
      height="700px"
      width="800px"
    >
      <template v-slot:grid>
        <div class="v-application">
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="sdsManageGrid"
                  width="100%"
                  height="500px"
                  :ref="dxSdsManageGridRef"
                  :data-source="sdsManageData"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :selection="{ mode: 'single' }"
                  key-expr="id"
                  :focused-row-enabled="true"
                  @row-updating="onSdsManageRowUpdating"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

                  <DxColumn width="180px" data-field="sdsNm" data-type="string" alignment="left" caption="화학물질명" :allow-editing="true" />
                  <DxColumn width="130px" data-field="casNo" data-type="string" alignment="center" caption="CAS NO." :allow-editing="true" />
                  <DxColumn width="70px" data-field="ordSeq" data-type="number" alignment="center" caption="순번" :allow-editing="true" />
                  <DxColumn
                    width="70px"
                    data-field="useYn"
                    data-type="string"
                    alignment="center"
                    caption="사용"
                    cell-template="popupCheckBoxCellTemplate"
                    :allow-editing="false"
                  />
                  <template #popupCheckBoxCellTemplate="{ data: cellInfo }">
                    <DxCheckBox
                      :value="cellInfo.value == 'Y' ? true : false"
                      :onValueChanged="(value) => onPopupCheckValueChanged(value, cellInfo)"
                    />
                  </template>

                  <DxColumn data-field="fileNm" caption="파일명" data-type="string" :visible="false" />
                  <DxColumn data-field="file" caption="파일" data-type="string" :visible="false" />
                  <DxColumn data-field="__fileUpdate__" caption="파일수정여부" data-type="boolean" :visible="false" />

                  <DxColumn
                    width="260px"
                    data-field="extension"
                    cell-template="sdsManageFileCellTemplate"
                    edit-cell-template="sdsManageFileCellTemplate"
                    caption="파일"
                    alignment="left"
                    :allow-editing="false"
                  />
                  <template #sdsManageFileCellTemplate="{ data: cellInfo }">
                    <v-row no-gutters>
                      <v-col class="pl-2 pt-1 d-flex" cols="10">
                        <span class="dx-datagrid-content-file-name-text">{{ getSdsManageDisplayFileName(cellInfo.data) }}</span>
                        <span class="pl-2 d-flex align-center">
                          <v-btn
                            v-if="hasSdsManageFile(cellInfo.data)"
                            elevation="0"
                            color="btn_sub"
                            dark
                            x-small
                            @click="sdsManageFileDownload(cellInfo.data)"
                          >
                            다운로드
                          </v-btn>
                        </span>
                      </v-col>
                      <v-col align="right" cols="2">
                        <v-btn icon v-if="hasSdsManageFile(cellInfo.data)" role="clear" @click="sdsManageClearClick(cellInfo)">
                          <svg-icon icon-class="close"></svg-icon>
                        </v-btn>
                        <v-btn
                          v-if="!hasSdsManageFile(cellInfo.data)"
                          elevation="0"
                          color="btn_sub"
                          dark
                          x-small
                          class="pa-1 mr-2"
                          role="upload"
                          @click="sdsManageUploadClick(cellInfo)"
                        >
                          업로드
                        </v-btn>
                      </v-col>
                    </v-row>
                  </template>
                </DxDataGrid>
                <DxFileUploader
                  :ref="dxSdsManageFileUploaderRef"
                  :multiple="false"
                  upload-mode="useButton"
                  :visible="false"
                  @value-changed="onSdsManageFileValueChanged"
                />
              </v-col>
            </v-col>
          </v-layout>
        </div>
      </template>
      <template v-slot:footer>
        <div class="v-application">
          <v-row class="d-flex justify-end" style="gap: 12px; padding-right: 10px">
            <v-btn elevation="0" large color="primary" class="float-right rounded mt-1" @click="btnManagePopupAdd">추가</v-btn>
            <v-btn elevation="0" large color="primary" class="float-right rounded mt-1" @click="btnManagePopupSave">저장</v-btn>
            <v-btn elevation="0" large color="desc_text" class="float-right rounded mt-1" @click="sdsManagePopupVisible = false">닫기</v-btn>
          </v-row>
        </div>
      </template>
    </i-dxpopup>

    <!-- 소중안 제공 데이터 불러오기 팝업 -->
    <i-dxpopup
      :popupVisible="sampleDataPopupVisible"
      :title="'소중안 제공 데이터 불러오기'"
      @popupCloseButtonClick="btnSamplePopupClose"
      height="720px"
      width="650px"
    >
      <template v-slot:grid>
        <div class="v-application">
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <i-search-panel :searchPanel="true" style="margin-bottom: 10px"></i-search-panel>
                <DxDataGrid
                  id="sampleGrid"
                  width="100%"
                  height="500px"
                  :ref="dxSampleDataGridRef"
                  :data-source="sampleData"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :selection="{ mode: 'single' }"
                  key-expr="id"
                  :focused-row-enabled="true"
                >
                  <DxEditing mode="batch" :allow-updating="false" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

                  <DxColumn width="280px" data-field="sdsNm" data-type="string" alignment="left" caption="화학물질명" :allow-editing="false" />
                  <DxColumn width="150px" data-field="casNo" data-type="string" alignment="center" caption="CAS NO." :allow-editing="false" />

                  <DxColumn
                    width="80px"
                    data-field="fileDownload"
                    data-type="string"
                    alignment="center"
                    caption="파일"
                    :allow-editing="false"
                    cell-template="fileDownloadTemplate"
                  />
                  <template #fileDownloadTemplate="{ data: cellInfo }">
                    <v-btn elevation="0" color="btn_sub" width="55" dark x-small class="rounded" @click="sampleFileDownload(cellInfo)">
                      <div>다운로드</div>
                    </v-btn>
                  </template>
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </div>
      </template>
      <template v-slot:footer>
        <div class="v-application">
          <v-row class="d-flex justify-end" style="gap: 12px; padding-right: 10px">
            <v-btn elevation="0" large color="primary" class="float-right rounded mt-1" @click="btnSamplePopupApply">적용</v-btn>
            <v-btn elevation="0" large color="desc_text" class="float-right rounded mt-1" @click="btnSamplePopupClose('close')">닫기</v-btn>
          </v-row>
        </div>
      </template>
    </i-dxpopup>
  </v-container>
</template>
<script>
// components
import iCardRight from '@/components/common/iCardRight.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import iDxPopup from '@/components/common/iDxPopup.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import { getGrpAuthCd } from '@/utils/token'
// utils
import { getExtension } from '@/utils/common.js'
// api
import {
  getSafetyDataSheetManageList,
  saveSafetyDataSheetManageList,
  deleteSafetyDataSheetManageList,
  getSafetyDataSheetManageSampleData,
  saveSafetyDataSheetManageSampleData,
  deleteSafetyDataSheetManageSampleData,
} from '@/api/riskAssessment/SafetyDataSheetManage'
import { deleteFilesWithTarget, deleteFiles, multiFileUpload, downloadFile } from '@/api/baseManage/fileUpload'
import { DxFileUploader } from 'devextreme-vue/file-uploader'

import iSearchPanel from '@/components/common/iSearchPanel.vue'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'SafetyDataSheetManage',
  components: {
    'i-card-vertical': iCardVertical,
    'i-dxpopup': iDxPopup,
    iCardRight,
    iFileManage,
    DxFileUploader,
    iSearchPanel,
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete', //삭제
      ],
      dxDataGridRef: 'mainGrid',
      dxSampleDataGridRef: 'sampleGrid',
      dxSdsManageGridRef: 'sdsManageGrid',
      dxSdsManageFileUploaderRef: 'sdsManageFileUploader',
      currentSdsManageCellInfo: null,
      gridMain: [],
      sampleData: [],
      sdsManageData: [],
      allMode: 'allPages',
      title: '',
      sdsManagePopupVisible: false,
      sampleDataPopupVisible: false,
      selectedDataIndex: -1,
      // 파일 관련
      fileListForm: {
        insert: [],
        delete: [],
      },
      guideHighlightSample: false, // 안전보건관리체계 구축 진행도 이동 시 소중안 제공 데이터 불러오기 깜빡임
      _guideHighlightTimer: null,
    }
  },
  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
    selectedData: function () {
      return this.gridMain[this.selectedDataIndex]
    },
    isMasterConfig() {
      return getGrpAuthCd() === 'master'
    },
  },
  watch: {
    // 안전보건관리체계 구축 진행도에서 같은 경로로 재이동할 때(query._t) 가이드 하이라이트 재적용
    '$route.query._t'(val, oldVal) {
      if (val && oldVal && val !== oldVal && this.$route.params?.data?.guideHighlight) {
        this.applyGuideHighlightFromRoute()
      }
    },
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
    this.applyGuideHighlightFromRoute()
  },
  activated() {
    if (this.$route.params?.data?.guideHighlight) {
      this.applyGuideHighlightFromRoute()
    }
    if (this.$route.params?.search) {
      // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
      this.btnSearch(true)
    }
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  methods: {
    // 안전보건관리체계 구축 진행도에서 진입 시 소중안 제공 데이터 불러오기 버튼을 붉게 깜빡여 안내
    applyGuideHighlightFromRoute() {
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData || !routeData.guideHighlight) return

      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightSample = false
      this.$nextTick(() => {
        this.guideHighlightSample = true
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightSample = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  조회
    //------------------------------------------
    async btnSearch(notify = true) {
      this.openLoading('searching')
      this.GetDataGrid(this.dxDataGridRef).endUpdate()
      getSafetyDataSheetManageList({ clntId: this.getClntId(), compId: this.getCompId() }, notify)
        .then((res) => {
          res.list?.forEach((el) => {
            el.originFileList = el.fileList
            el.saveFileList = _.cloneDeep(this.fileListForm)
          })
          this.gridMain = res.list || []
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(async () => {
          await this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          await this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          this.endLoading()
        })
    },
    //------------------------------------------
    //  추가
    //------------------------------------------

    btnAdd() {
      // grid row를 최상단에 추가
      let newRow = {
        id: this.gridMain.length + 1,
        sdsId: null,
        sdsNm: '',
        casNo: '',
        fileList: [],
        saveFileList: {
          insert: [],
          delete: [],
        },
        datasetYn: 'N',
        useYn: 'Y',
        ordSeq: 0,
        clntId: this.getClntId(),
        compId: this.getCompId(),
      }
      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },

    //------------------------------------------
    //  저장
    //------------------------------------------

    async btnSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      this.GetDataGrid(this.dxDataGridRef).saveEditData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      if (selectedRows.some((row) => row.sdsNm === '')) {
        this.vSnackbar('화학물질명은 필수입력 값입니다.', 'warn')
        return
      }
      console.log('# selectedRows', selectedRows)
      this.vToastifyPrompt(`${selectedRows.length}개의 데이터를 저장하시겠습니까?`, 'info', async (current) => {
        this.openLoading('saving')
        // selectedRows를 순회하며 API 호출
        const saveRowPromises = selectedRows.map((row) => {
          row.clntId = this.getClntId()
          row.compId = this.getCompId()
          return saveSafetyDataSheetManageList([row], true).then(async (res) => {
            if (res.success) {
              if (row.saveFileList) {
                row.saveFileList.delete.forEach((el) => {
                  el.targetId = res.list[0].clntId + '_' + res.list[0].compId + '_' + res.list[0].sdsId
                })
                row.saveFileList.insert.forEach((el) => {
                  el.targetId = res.list[0].clntId + '_' + res.list[0].compId + '_' + res.list[0].sdsId
                })
                return await this.saveFile(row.saveFileList)
              }
            } else {
              // saveFile 실행 안 함
              return new Promise((resolve) => {
                resolve(true)
              })
            }
          })
        })
        // saveFile이 모두 끝난 뒤에 btnSearch 실행
        Promise.all(saveRowPromises)
          .then(() => {
            this.endLoading()
            this.btnSearch(false)
          })
          .catch(() => {
            this.endLoading()
          })
      })
    },
    saveFile(files) {
      // 항상 프로미스를 반환하도록 수정
      return new Promise((resolve, reject) => {
        deleteFiles(files.delete, false)
          .then((res) => {
            if (res.success) {
              if (files.insert.length == 0) {
                resolve(true)
                return
              }
              let formData = new FormData()
              let i = 0
              files.insert.forEach((element) => {
                formData.append('fileList[' + i + '].fileData', element.file ? element.file : new Blob([], { type: 'application/octet-stream' }))
                formData.append('fileList[' + i + '].fileVO.targetId', element.targetId)
                formData.append('fileList[' + i + '].fileVO.targetType', '00023')
                formData.append('fileList[' + i + '].fileVO.useYn', element.useYn)
                formData.append('fileList[' + i + '].fileVO.clntId', element.clntId)
                i++
              })
              multiFileUpload(formData, false)
                .then((res) => {
                  // 성공 여부에 상관없이 resolve 호출
                  resolve(true)
                })
                .catch((err) => {
                  resolve(true)
                })
            } else {
              resolve(true)
            }
          })
          .catch(() => {
            resolve(true)
          })
      })
    },

    //------------------------------------------
    //  삭제
    //------------------------------------------
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      this.vToastifyPrompt(`${selectedRows.length}개의 데이터를 삭제하시겠습니까?`, 'info', async (current) => {
        this.openLoading('deleting')
        const deleteRowPromises = selectedRows.map((row) => {
          return deleteSafetyDataSheetManageList([row], true).then((res) => {
            if (res.success) {
              const param = {
                clntId: row.clntId,
                targetType: '00023',
                targetId: row.targetId,
              }
              if (row.datasetYn === 'N') {
                deleteFilesWithTarget(param).then((res) => {
                  //
                })
              }
            }
          })
        })
        Promise.all(deleteRowPromises).finally(() => {
          this.endLoading()
          this.btnSearch(false)
        })
      })
    },
    // 교육 계획 상세 화면 이동
    btnGoEducationMenu() {
      this.vToastifyPrompt('교육계획 화면으로 이동하시겠습니까?', 'info', async (current) => {
        const toRouter = {
          name: 'EducationPlanDetail',
          params: {
            data: {
              sdsData: this.gridMain.filter((el) => el.useYn === 'Y' && el.__created__ === false),
              __created__: true,
            },
          },
        }
        this.$router.push(toRouter)
      })
    },
    onEditingStart(e) {
      //소중안 데이터셋은 수정 불가능하게 설정
      if ((e.column.dataField == 'sdsNm' || e.column.dataField == 'casNo') && e.data.datasetYn === 'Y') {
        this.vSnackbar(`소중안 제공 데이터의 ${e.column.caption}은(는) 수정이 불가능합니다.`, 'warn')
        e.cancel = true
      } else e.cancel = false
    },
    onRowUpdating(e) {
      var datagrid = this.GetDataGrid(this.dxDataGridRef)
      datagrid.selectRows(e.key, true)
    },
    // ------------------------------------------
    // 파일 관리 팝업
    // ------------------------------------------
    // 파일 관리 팝업 버튼 클릭
    btnFilePopup(cellInfo) {
      console.log('##cellInfo', cellInfo)
      this.selectedDataIndex = cellInfo.row.dataIndex

      this.GetDataGrid(this.dxDataGridRef).saveEditData()
      this.$set(this.selectedData, 'filePopupVisible', true)
      this.$nextTick(() => {
        this.filePopupOpen(cellInfo)
      })
    },
    // 파일 관리 팝업 열기
    filePopupOpen(cellInfo) {
      setTimeout(() => {
        this.$refs[`detailFileUpload_${this.selectedData.id}`].files = _.cloneDeep(cellInfo.data.fileList)
        this.$refs[`detailFileUpload_${this.selectedData.id}`].newFiles = []
      }, 100)
    },
    // 파일 팝업 적용
    btnFilePopupApply(cellInfo) {
      let datasetChanged = false
      if (this.selectedData.saveFileList.delete.length == 0 && this.selectedData.saveFileList.insert.length == 0) {
        this.btnFilePopupClose()
        return
      } else if (this.selectedData.saveFileList.delete.length == 0 && this.$refs[`detailFileUpload_${this.selectedData.id}`].newFiles.length === 0) {
        this.btnFilePopupClose()
        return
      }
      if (this.selectedData.datasetYn === 'Y') {
        // 소중안 제공 파일을 변경하려 할 때
        if (
          this.selectedData.fileList &&
          Array.isArray(this.selectedData.saveFileList.delete) &&
          this.selectedData.fileList.some((file) =>
            this.selectedData.saveFileList.delete.map((el) => el.clntId + el.docNo + el.targetId).includes(file.clntId + file.docNo + file.targetId)
          )
        ) {
          // 파일명 중 삭제 배열에 포함된 것이 있다.
          datasetChanged = true
        } else if (this.selectedData.saveFileList.insert.length > 0) {
          datasetChanged = true
        }
      }
      if (datasetChanged) {
        this.vToastifyPrompt('소중안 제공 파일을 변경하시겠습니까?', 'info', async (current) => {
          // delete 리스트에 없는 기존 fileList 항목 + delete 리스트에 없는 insert 항목 합쳐서 할당
          let filteredOldFiles = this.selectedData.fileList.filter((file) => {
            return !this.selectedData.saveFileList.delete.some(
              (deleteItem) => file.fileNm === deleteItem.fileNm && file.extension === deleteItem.extension && file.fileSize === deleteItem.fileSize
            )
          })
          const filteredInsertFiles = this.selectedData.saveFileList.insert
          this.selectedData.fileList = [...filteredOldFiles, ...filteredInsertFiles]
          if (this.selectedData.datasetYn === 'Y') {
            // 기존 데이터셋 사용중인 항목에서 파일을 추가할 경우 대응
            filteredOldFiles.forEach((file) => {
              downloadFile(file).then((res) => {
                file.clntId = this.getClntId()
                file.targetType = '00023'
                file.targetId = this.getClntId() + '_' + this.selectedData.sdsId

                // Blob 형태의 결과를 File 형태로 변환(바로 저장하기 위해)
                const fileName = `${file.fileNm}.${file.extension}`
                let fileType = file.type || 'application/octet-stream'
                try {
                  file.file = new File([res], fileName, { type: fileType })
                } catch (e) {
                  file.file = res
                }
                console.log('file ==> ', file)
              })
            })
            this.selectedData.saveFileList.insert = [...this.selectedData.saveFileList.insert, ...filteredOldFiles]
            console.log('this.selectedData ==> ', this.selectedData)
            this.selectedData.saveFileList.delete = _.cloneDeep(this.fileListForm.delete)
          }
          this.selectedData.datasetYn = 'N'
          // 그리드에서 해당 row가 선택되도록 처리

          this.GetDataGrid(this.dxDataGridRef).selectRows(this.selectedData.id, true)
          this.btnFilePopupClose()
        })
        return
      } else {
        // insert 배열에서 delete 배열에 존재하지 않는 항목만 fileList에 바인딩
        // delete 리스트에 없는 기존 fileList 항목 + delete 리스트에 없는 insert 항목 합쳐서 할당
        const filteredOldFiles = this.selectedData.fileList.filter((file) => {
          return !this.selectedData.saveFileList.delete.some(
            (deleteItem) => file.fileNm === deleteItem.fileNm && file.extension === deleteItem.extension && file.fileSize === deleteItem.fileSize
          )
        })
        const filteredInsertFiles = this.selectedData.saveFileList.insert.filter((insertItem) => {
          return !this.selectedData.saveFileList.delete.some(
            (deleteItem) =>
              insertItem.fileNm === deleteItem.fileNm && insertItem.extension === deleteItem.extension && insertItem.fileSize === deleteItem.fileSize
          )
        })
        this.selectedData.fileList = [...filteredOldFiles, ...filteredInsertFiles]
        // find로 첫번째 일치하는 row만 갱신 순회
        const targetIdx = this.gridMain.findIndex((row) => row.id === this.selectedData.id)
        if (targetIdx !== -1) {
          // 새로운 배열로 대입
          this.gridMain[targetIdx].filePopupVisible = false
          this.$set(this.gridMain, targetIdx, {
            ...this.gridMain[targetIdx],
            fileList: [...this.selectedData.fileList],
          })
        }
        this.$nextTick(() => {
          this.GetDataGrid(this.dxDataGridRef).selectRows(this.selectedData.id, true)
        })
      }
    },
    // 파일 관리 팝업 닫기
    btnFilePopupClose(rowIndex) {
      if (rowIndex !== 'close') {
        this.$refs[`detailFileUpload_${this.selectedData.id}`].saveFileList = _.cloneDeep(this.fileListForm)
      }
      // row 편집(save) 반영을 위해 강제로 batch update commit
      // 팝업 닫기 전에 batch 업데이트 변경 사항 저장
      const dataGrid = this.GetDataGrid(this.dxDataGridRef)
      dataGrid.saveEditData && dataGrid.saveEditData()
      this.$set(this.selectedData, 'filePopupVisible', false)
    },
    onFileChanged(cellInfo, fileList) {
      cellInfo.data.saveFileList = fileList
    },
    // ------------------------------------------
    // 소중안 제공 데이터 불러오기 팝업
    // ------------------------------------------
    // 소중안 제공 데이터 관리(관리자)
    btnSdsManage() {
      this.openLoading()
      this.loadSdsManageData(true)
        .then(() => {
          this.sdsManagePopupVisible = true
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // 소중안 제공 데이터 불러오기 버튼 클릭
    btnSdsSampleData() {
      this.openLoading()
      getSafetyDataSheetManageSampleData({})
        .then((res) => {
          this.sampleData = res.list
          this.sampleDataPopupVisible = true
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnManagePopupAdd() {
      const newId = this.sdsManageData.length > 0 ? Math.max(...this.sdsManageData.map((row) => Number(row.id) || 0)) + 1 : 1
      const newRow = {
        id: newId,
        sdsId: null,
        sdsNm: '',
        casNo: null,
        ordSeq: this.sdsManageData.length + 1,
        useYn: 'Y',
        fileNm: '',
        extension: '',
        file: '',
        fileList: [],
        __fileUpdate__: false,
      }
      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      const grid = this.GetDataGrid(this.dxSdsManageGridRef)
      grid.newRow(newRow)
      grid.selectRows(newRow.id, true)
    },
    async btnManagePopupSave() {
      const grid = this.GetDataGrid(this.dxSdsManageGridRef)
      let selectedRows = await grid.getSelectedRowsData()
      grid.saveEditData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      if (selectedRows.some((row) => !row.sdsNm || row.sdsNm.trim() === '')) {
        this.vSnackbar('화학물질명은 필수입력 값입니다.', 'warn')
        return
      }
      if (selectedRows.some((row) => row.__created__ && !this.hasSdsManageFile(row))) {
        this.vSnackbar('신규 등록 시 파일을 업로드해주세요.', 'warn')
        return
      }
      this.vToastifyPrompt(`${selectedRows.length}개의 데이터를 저장하시겠습니까?`, 'info', async () => {
        const saveData = selectedRows.map((row) => this.buildSdsManageSaveRow(row))
        this.openLoading('saving')
        saveSafetyDataSheetManageSampleData(saveData, true)
          .then((res) => {
            if (res.success) {
              this.loadSdsManageData(false)
              this.sdsManagePopupVisible = false
            }
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    loadSdsManageData(notify = true) {
      return getSafetyDataSheetManageSampleData({}, notify).then((res) => {
        this.sdsManageData = res.list || []
        return res
      })
    },
    buildSdsManageSaveRow(row) {
      const payload = {
        sdsId: row.sdsId,
        sdsNm: row.sdsNm,
        casNo: row.casNo,
        ordSeq: row.ordSeq,
        useYn: row.useYn || 'Y',
        __created__: row.__created__,
      }
      const fileList = this.buildSdsManageFileList(row)
      if (fileList.length > 0) {
        payload.fileList = fileList
      }
      return payload
    },
    buildSdsManageFileList(row) {
      if (row.file) {
        const file = this.base64ToFile(row)
        return [
          {
            file,
            fileNm: row.fileNm,
            extension: row.extension,
            useYn: 'Y',
            clntId: this.getClntId(),
            targetType: '00023',
            __created__: true,
          },
        ]
      }
      if (row.__fileUpdate__ && !row.file && row.fileList?.length > 0) {
        return row.fileList.map((file) => ({
          ...file,
          __deleted__: true,
        }))
      }
      return []
    },
    base64ToFile(row) {
      const arr = row.file.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${row.fileNm}.${row.extension}`, { type: mime })
    },
    hasSdsManageFile(row) {
      return !!(row.fileNm || (row.fileList && row.fileList.length > 0))
    },
    getSdsManageDisplayFileName(row) {
      if (row.fileNm) {
        return row.extension ? `${row.fileNm}.${row.extension}` : row.fileNm
      }
      if (row.fileList?.length > 0) {
        const file = row.fileList[0]
        return `${file.fileNm}.${file.extension}`
      }
      return ''
    },
    sdsManageUploadClick(cellInfo) {
      this.currentSdsManageCellInfo = cellInfo
      const fileInstance = this.$refs[this.dxSdsManageFileUploaderRef].instance
      const uploadButton = fileInstance.element().querySelector('.dx-button-content')
      uploadButton.click()
    },
    sdsManageClearClick(cellInfo) {
      const grid = this.GetDataGrid(this.dxSdsManageGridRef)
      const rowIndex = cellInfo.row.rowIndex
      grid.cellValue(rowIndex, 'extension', '')
      grid.cellValue(rowIndex, 'fileNm', '')
      grid.cellValue(rowIndex, 'file', '')
      grid.cellValue(rowIndex, '__fileUpdate__', true)
      cellInfo.data.fileList = []
      grid.selectRows(cellInfo.key, true)
    },
    onSdsManageFileValueChanged(e) {
      const file = e.value?.[0]
      if (!file || !this.currentSdsManageCellInfo) {
        return
      }
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const subFileName = getExtension(file.name)
        const grid = this.GetDataGrid(this.dxSdsManageGridRef)
        const rowIndex = this.currentSdsManageCellInfo.row.rowIndex
        grid.cellValue(rowIndex, 'extension', subFileName[1])
        grid.cellValue(rowIndex, 'fileNm', subFileName[0])
        grid.cellValue(rowIndex, 'file', reader.result)
        grid.cellValue(rowIndex, '__fileUpdate__', true)
        this.currentSdsManageCellInfo.data.fileList = []
        grid.selectRows(this.currentSdsManageCellInfo.key, true)
      }
      reader.onerror = () => {
        this.vSnackbar('파일업로드에 실패하였습니다. 다시 시도해주시기 바랍니다.', 'error')
      }
    },
    onPopupCheckValueChanged(value, cellInfo) {
      // cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      cellInfo.data.useYn = cellInfo.value === 'Y' ? 'N' : 'Y'
      this.GetDataGrid(this.dxSdsManageGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },
    sdsManageFileDownload(row) {
      if (row.file) {
        const link = document.createElement('a')
        link.href = row.file
        link.download = `${row.fileNm}.${row.extension}`
        link.click()
        return
      }
      this.sampleFileDownload({ data: row })
    },
    onSdsManageRowUpdating(e) {
      this.GetDataGrid(this.dxSdsManageGridRef).selectRows(e.key, true)
    },
    // 소중안 제공 데이터 불러오기 팝업 적용
    async btnSamplePopupApply() {
      let selectedRows = await this.GetDataGrid(this.dxSampleDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      // this.gridMain에 중복된 데이터를 제거하고 추가
      // 중복 기준: sdsId가 동일한 경우
      const existingIds = new Set(this.gridMain.map((row) => row.id))
      let nonDuplicateRows = selectedRows.filter((row) => !existingIds.has(row.id))
      let duplicateRows = selectedRows.filter((row) => existingIds.has(row.id))
      if (nonDuplicateRows.length === 0) {
        this.vSnackbar(this.$t('선택한 데이터가 이미 추가되어 있습니다.'), 'warn')
        return
      }
      const msg =
        duplicateRows.length > 0
          ? `중복된 데이터 ${duplicateRows.length}개를 제외한 ${nonDuplicateRows.length}개의 데이터를 적용하시겠습니까?`
          : `${nonDuplicateRows.length}개의 데이터를 적용하시겠습니까?`
      console.log('# 저장 데이터 => ', nonDuplicateRows)
      this.vToastifyPrompt(msg, 'info', async (current) => {
        nonDuplicateRows.forEach((row) => {
          row.__created__ = true
        })
        // 새로 추가되는 데이터가 제일 상단에 오도록
        this.gridMain = nonDuplicateRows.concat(this.gridMain)
        this.GetDataGrid(this.dxDataGridRef).selectRows(
          nonDuplicateRows.map((row) => row.id),
          true
        )
        this.sampleDataPopupVisible = false
      })
    },
    // 소중안 제공파일 다운로드
    sampleFileDownload(cellInfo) {
      console.log('cellInfo ==> ', cellInfo)
      cellInfo.data.fileList.forEach((file) => {
        const param = {
          clntId: file.clntId,
          writeDt: file.writeDt,
          docNo: file.docNo,
        }
        downloadFile(param).then((res) => {
          let link = document.createElement('a')
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          link.href = objectUrl
          link.download = `${file.fileNm}.${file.extension}`
          link.click()
        })
      })
    },
    // 소중안 제공 데이터 불러오기 팝업 닫기
    btnSamplePopupClose() {
      this.sampleDataPopupVisible = false
    },
    onCheckValueChanged(value, cellInfo) {
      // cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      cellInfo.data.useYn = cellInfo.value === 'Y' ? 'N' : 'Y'
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/theme/variables.scss';
.tooltip-text {
  word-break: keep-all;
}
.dx-datagrid-content-file-name-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@keyframes guide-blink-red {
  0%,
  100% {
    color: inherit;
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    color: #f44336 !important;
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-blink-target {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
